import { Tooltip, TooltipProps } from '@quillbot/design-system';
import React from 'react';
import { APP_SETTINGS } from 'config/constants';

interface QBTooltipProps extends TooltipProps {
  mandatory?: boolean;
}

export function QBTooltip(props: QBTooltipProps) {
  const showTooltip = props.mandatory || APP_SETTINGS.showToolTips;
  return (
    <Tooltip {...props} title={showTooltip ? props.title : ''}>
      {props.children}
    </Tooltip>
  );
}

export default QBTooltip;
